import { TransitiveCompileNgModuleMetadata } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { date } from '@rxweb/reactive-forms';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { Subject } from 'rxjs';
import { Onderneming } from 'src/app/models/Onderneming';
import { DataService } from 'src/app/services/data.service';
import { lijstParitaireComites, OpzegtermijnItem, LijstParitaireComites, tabel1, tabel2, tabel4, tabel5, tabel6, tabel7 } from '../../models/Opzegtermijn';



interface OpzegtermijnForm {
  isWerkgever: Boolean | null,
  isBediende: Boolean | null,
  grensdatum2014: Boolean | null,
  grensdatum2012: Boolean | null,
  brutojaarloonKlasse: string | null,
  datumOntslag: Date | null,
  datumInDienst: Date | null,
  paritairComite: string | null,
}

@Component({
  selector: 'app-opzegtermijn',
  templateUrl: './opzegtermijn.component.html',
  styleUrls: ['./opzegtermijn.component.scss']
})
export class OpzegtermijnComponent implements OnInit {
  //Boolean voor het vertonen van de uitkomst
  calculate = false;

  //Huidige onderneming
  onderneming: Onderneming;

  //form variabelen
  formBuilder: IFormBuilder;
  opzegtermijnFormGroup: IFormGroup<OpzegtermijnForm>;


  lijstParitaireComites = lijstParitaireComites;

  //Uitkomst van opzegtermijn
  resultaat: string;
  //Indien de ontslagen persoon recht heeft op outplacement
  rechtOutplacement: Boolean;
  //Het totaal aantal weken opzegtermijn dat de ontslagen persoon ontvangt
  totaalAantalWekenOpzegtermijn: number;
  //Auto unsubscribe
  componentDestoryed$: Subject<boolean> = new Subject();


  data: OpzegtermijnForm = {
    isWerkgever: true,
    isBediende: true,
    grensdatum2014: false,
    grensdatum2012: false,
    brutojaarloonKlasse: "1",
    datumInDienst: null,
    paritairComite: null,
    datumOntslag: null,
  }

  constructor(public dataService: DataService,

    formBuilder: FormBuilder,) {
    this.formBuilder = formBuilder

  }

  /**
   * Initilisatie van validatie en formulier via reactforms
   */
  ngOnInit(): void {
    this.opzegtermijnFormGroup = this.formBuilder.group<OpzegtermijnForm>({
      isWerkgever: this.formBuilder.control(true),
      isBediende: this.formBuilder.control(true),
      grensdatum2014: this.formBuilder.control(false),
      grensdatum2012: this.formBuilder.control(false),
      brutojaarloonKlasse: this.formBuilder.control(null),
      datumOntslag: this.formBuilder.control(null, [Validators.required]),
      paritairComite: this.formBuilder.control(null),
      datumInDienst: this.formBuilder.control(null, [Validators.required]),

    }, {
      validator: this.dateLessThan("datumInDienst","datumOntslag")})
    this.loadData();
  }

  /**
   * Validatie zodat de einddatum alleen later kan voorkomen dan de startdatum
   * @param from startdatum
   * @param to einddatum
   */
  dateLessThan(from: string, to: string) {
    return (group: FormGroup): {[key: string]: any} => {
      let f = group.controls[from];
      let t = group.controls[to];
      if (f.value > t.value) {
        return {
          dates: "Ontslagdatum moet later zijn dan datum in dienst"
        };
      }
      return {};
    }
}

  /**
   * Inladen van de benodigde data
   */
  loadData() {
    this.onderneming = this.dataService.getOnderneming();
  }

  /**
   * Wordt uitgevoerd na het drukken van "BEREKEN"
   */
  onSubmit() {
    //Geslecteerde waardes door de gebruiker
    this.data = {
      isWerkgever: this.data.isWerkgever,
      isBediende: this.data.isBediende,
      grensdatum2014: this.data.grensdatum2014,
      grensdatum2012: this.data.grensdatum2012,
      brutojaarloonKlasse: this.data.brutojaarloonKlasse,
      paritairComite: this.opzegtermijnFormGroup.value.paritairComite,
      datumInDienst: this.opzegtermijnFormGroup.value.datumInDienst,
      datumOntslag: this.opzegtermijnFormGroup.value.datumOntslag,

    }
    this.totaalAantalWekenOpzegtermijn = 0;
    this.rechtOutplacement = false;
    this.berekenOpzegtermijn()
  }
  //###############################################################################################################################################################################
  /**
   * Update boolean variabelen wanneer nodig
   * 
   * @param selected welk item wordt er geselecteerd 
   * @param checkFor aan wat moet het item gelijk zijn
   * @var result resultaat van de methode (TRUE | FALSE)
   */
  checkBoolean(selected: string, checkFor: string): Boolean {
    var result = false;
    if (selected === checkFor) {
      result = true;
    }
    return result
  }

  /**
   * Controleert als een datum voor een bepaalde grensdatum2014 ligt
   * 
   * @param selected Welk item wordt er geselecteerd
   * @var result resultaat van de methode (TRUE | FALSE)
   * @var grensdatum2014 Datum waar het opzegtermijn anders berekend wordt
   */
  checkDate(selected: Date) {
    var grensdatum2014 = new Date(2014, 1, 1).getFullYear()
    var grensdatum2012 = new Date(2012, 1, 1).getFullYear()
    var selectedDate = new Date(selected).getFullYear()
    if (selectedDate < grensdatum2014) {
      this.data.grensdatum2014 = true;
    }
    else {
      this.data.grensdatum2014 = false;
    }
    if (selectedDate < grensdatum2012) {
      this.data.grensdatum2012 = true;
    }
    else {
      this.data.grensdatum2012 = false;
    }
  }
  //###############################################################################################################################################################################
  /**
   * Verstuurt de data naar de juiste methode om de berekening correct uit te voeren
   * @param data paramters voor berekeningen
   */
  berekenOpzegtermijn() {

    if (!this.data.grensdatum2014 && this.data.isWerkgever) {
      this.contractNa2014(tabel4) //case 1
      console.log("tabel 4 CASE 1")
    }
    else if (!this.data.grensdatum2014 && !this.data.isWerkgever) {
      this.contractNa2014(tabel7) //case 2
      console.log("tabel 7 CASE 2")
    }
    else if (this.data.grensdatum2014 && this.data.grensdatum2012 && !this.data.isBediende && this.data.isWerkgever) {
      this.vergelijkIndex(tabel1, this.data.paritairComite, tabel4)  //case 3
      console.log("tabel 1 en 4 CASE 3")

    }
    else if (this.data.grensdatum2014 && !this.data.grensdatum2012 && !this.data.isBediende && this.data.isWerkgever) {
      this.vergelijkIndex(tabel2, this.data.paritairComite, tabel4) //case 4
      console.log("tabel 2 en 4 CASE 4")
    }
    else if (this.data.grensdatum2014 && this.data.isWerkgever && this.data.isBediende) {
      var deelres1 = this.berekenAncieniteitMetLoon();
      var deelres2 = null;
      //Bereken aantal weken
      console.log("tabel 3 en 4 CASE 5")
      var datumOntslag = new Date(this.data.datumOntslag).getFullYear();

      //Indien de ontslagdatum in of na 2014
      if(datumOntslag >=  2014)
      {
        deelres2 = this.berekenWekenOpzegtermijn(tabel4);
      }
      
      this.samenvoegenDeelresultaat(deelres1, deelres2);//case 5
    }
    else if (this.data.grensdatum2014 && !this.data.isWerkgever && !this.data.isBediende) {
      this.vergelijkIndex(tabel5, this.data.paritairComite, tabel7)//case 6
      console.log("tabel 5 en 7 CASE 6")
    }
    else if (this.data.grensdatum2014 && !this.data.isWerkgever && this.data.isBediende) {
      var tabel = this.vulIndexTabel(tabel6, this.data.brutojaarloonKlasse)//case 7
      console.log(tabel)
      var datumInDienst  = new Date(this.data.datumInDienst);
      if(datumInDienst.getFullYear() > 2008)
      {
        this.resultaat = this.berekenMaandenOpzegtermijn(tabel, " weken");
      }
      else
      {
        this.resultaat = this.berekenMaandenOpzegtermijn(tabel, " maanden");
      }
      console.log("tabel 6 case 7")
    }
  }
  //###############################################################################################################################################################################
  /**
   * 
   * @param tabel tabel die gebruikt moet worden voor de berekening
   * @param selected geslecteerde waarde door de gebruiker (paritair comite of brutoloon)
   * @param tabelWeken tabel die gebruikt moet worden voor de berekening
   */
  vergelijkIndex(tabel: OpzegtermijnItem[], selected: string, tabelWeken: OpzegtermijnItem[]) {
    this.contractVoor2014(this.vulIndexTabel(tabel, selected), tabelWeken)
  }

  /**
   * Maakt een deeltabel aan met alleen de benodigde rijen (overeenkomstig paritair comité of brutoloon)
   * 
   * @param tabel tabel die gebruikt moet worden voor de berekening
   * @param selected geslecteerde waarde door de gebruiker (paritair comite of brutoloon)
   */
  vulIndexTabel(tabel: OpzegtermijnItem[], selected: string): OpzegtermijnItem[] {
    var tabelPc: OpzegtermijnItem[] = [];
    for (var i = 0; i < tabel.length; i++) {
      if (tabel[i].index === selected) {
        tabelPc.push(tabel[i]);

      }
    }
    //Indien niks gevonden, gebruik de standaard waardes, vooraan in de tabel
    if (tabelPc.length == 0) {
      tabelPc = this.onbekendPc(tabel);
    }
    return tabelPc
  }
  /**
   * Indien er geen overeenkomstig paritair comité gevonden wordt in de tabel, worden er standaardwaardes gebruikt
   * 
   * @param tabel tabel die gebruikt moet worden voor de berekening
   */
  onbekendPc(tabel: OpzegtermijnItem[]): OpzegtermijnItem[] {
    var defaultTabel: OpzegtermijnItem[] = []
    for (var i = 0; i < tabel.length; i++) {
      if (tabel[i].index === null) {
        defaultTabel.push(tabel[i])
      }
    }
    return defaultTabel;
  }

    /**
   * retourneerd het aantal maanden tussen 2 datums
   * @param dateFrom startdatum
   * @param dateTo  einddatum
   */
  maandVerschil(dateFrom: Date, dateTo: Date): number {

    var from = new Date(dateFrom);
    var to = new Date(dateTo);
    //console.log('aantal maand in maandVerschil: ' +  (to.getMonth() - from.getMonth() + (12 * (to.getFullYear() - from.getFullYear()))));
    return (to.getMonth() - from.getMonth() + (12 * (to.getFullYear() - from.getFullYear())))
  }
  //###############################################################################################################################################################################
    /**
   * Methode die gebruikt wordt indien de ontslagen werknemer begon te werken VOOR 2014
   * @param data informatie over het formulier
   */
  contractVoor2014(tabelPc: OpzegtermijnItem[], tabelWeken: OpzegtermijnItem[]) {
    var deelResultaat1 = " ";
    var deelResultaat2 = null;
    if (!this.data.isBediende) {
      deelResultaat1 = this.berekenDagenOpzegtermijn(tabelPc);
    }
    else {
      deelResultaat1 = this.berekenMaandenOpzegtermijn(tabelPc, " maanden");
    }
    var datumOntslag = new Date(this.data.datumOntslag).getFullYear();

    //Indien de ontslagdatum in of na 2014 is
    if(datumOntslag >=  2014)
    {
      deelResultaat2 = this.berekenWekenOpzegtermijn(tabelWeken);
    }
    this.samenvoegenDeelresultaat(deelResultaat1, deelResultaat2);
  }

  /**
   * Methode die gebruikt wordt indien de ontslagen werknemer begon te werken NA 2014
   * 
   * @param data informatie over het formulier
   * @param tabel tabel die gebruikt moet worden voor de berekening
   */
  contractNa2014(tabel: OpzegtermijnItem[]) {
    //Bereken aantal maanden tussen de 2 datums
    var aantalMaanden = this.maandVerschil(this.data.datumInDienst, this.data.datumOntslag);
    //Bereken het opzegtermijn
    this.resultaat = this.berekenResultaat(aantalMaanden, tabel, " weken",this.datumIndienstVroegerDanDatumOntslag(this.data.datumInDienst,this.data.datumOntslag));
  }

  //###############################################################################################################################################################################
  /**
   * Algoritme om het opzegtermijn te berekenen wanneer een bediende is ontslagen die er al werkt van voor 2014
   */
  berekenAncieniteitMetLoon(): string {
    var datumInDienst = new Date(this.data.datumInDienst);
    var resultaat = 3
    if (this.data.brutojaarloonKlasse === "1" && datumInDienst.getFullYear() <= 2008) {
      if (datumInDienst.getFullYear() == 2008) {
        resultaat = 6;
      }
      else {
        resultaat = Math.floor(((2008 - datumInDienst.getFullYear()) / 5)) * 3 + 6
      }

    }
    else if (this.data.brutojaarloonKlasse === "3" && datumInDienst.getFullYear() <= 2010) {
      if (datumInDienst.getFullYear() == 2010) {
        resultaat = 4;
      }
      else {
        resultaat = 2010 - datumInDienst.getFullYear() + 4;
      }
    }
    this.berekenOutplacement(" maanden",resultaat)
    return resultaat + this.naamgevingEenheid(" maanden",resultaat);
  }

  /**
   * Indien de ontslagen persoon meer dan 30 weken opzegtermijn krijgt, dan heeft hij recht op outplacement
   * @param eenheid eenheid waarin het resultaat staat verwerkt
   * @param resultaat aantal maanden/weken/dagen opzegtermijn
   */
  berekenOutplacement(eenheid: string, resultaat: number)
  {
    if(eenheid === " maanden" || eenheid === " maand")
    {
      this.totaalAantalWekenOpzegtermijn += resultaat * 4; 
    }
    else if(eenheid === " weken" || eenheid === " week")
    {
      this.totaalAantalWekenOpzegtermijn += resultaat;
    }
    else if(eenheid ===" dagen" || eenheid === " dag")
    {
      this.totaalAantalWekenOpzegtermijn += resultaat /7;
    }
  }

  /**
   * Indien de dag van indienstneming  vroeger in de maand was dan datum van ontslag
   * 
   * @returns   Retourneerd true indien de uitspraak waar is
   */
  datumIndienstVroegerDanDatumOntslag(startDate:Date, endDate:Date):boolean
  {
    var result = false;
    var startDag = new Date(startDate).getUTCDate();

    var eindDag = new Date(endDate).getUTCDate();


    // console.log("start " + startDag);
    // console.log("ontslag " + eindDag);

    if(startDag <= eindDag)
    {
      result = true;
    }
    return result;

  }
  /**
   * Berekent aantal maanden opzegtermijn van specifieke tabellen
   * 
   * @param tabelPc deeltabel die gebruikt moet worden voor de berekening
   * @param eenheid eenheid waarin het resultaat staat verwerkt
   */
  berekenMaandenOpzegtermijn(tabelPc: OpzegtermijnItem[], eenheid: string): string {
    var datumInDienst = new Date(this.data.datumInDienst);
    var jarenActief = datumInDienst.getFullYear()
    
    return this.berekenResultaat(jarenActief, tabelPc, eenheid,this.datumIndienstVroegerDanDatumOntslag(this.data.datumInDienst,this.data.datumOntslag))
  }

  /**
   * Berekent aantal dagen opzegtermijn van specifieke tabellen tot en met 31/12/2013
   * 
   * @param tabelPc deeltabel die gebruikt moet worden voor de berekening
   */
  berekenDagenOpzegtermijn(tabelPc: OpzegtermijnItem[]): string {
    //Bereken aantal dagen tussen de 2 datums (zelfde berekening als maanden)
    var ontslag = new Date("2013-12-31");
    var extraMaand = true;
    if(new Date(this.data.datumOntslag) < ontslag)
    {
      ontslag = new Date(this.data.datumOntslag);
      extraMaand = this.datumIndienstVroegerDanDatumOntslag(this.data.datumInDienst, ontslag)
    }
    var aantalMaanden = this.maandVerschil(this.data.datumInDienst, ontslag)
    //Bereken aantal dagen
    return this.berekenResultaat(aantalMaanden, tabelPc, " dagen",extraMaand);
  }

  /**
   * Berekent aantal weken opzegtermijn van specifieke tabellen tot en met 31/12/2013
   * 
   * @param tabelPc 
   */
  berekenWekenOpzegtermijn(tabelPc: OpzegtermijnItem[]): string {
    //Bereken aantal weken
    var aantalMaanden = this.maandVerschil(new Date("2014-01-01"), this.data.datumOntslag);
    return this.berekenResultaat(aantalMaanden, tabelPc, " weken",this.datumIndienstVroegerDanDatumOntslag(new Date("2014-01-01"),new Date(this.data.datumOntslag)));
  }
  //###############################################################################################################################################################################
  /**
   * 
   * @param ancieniteitMaand aantal maanden dat de werknemer in het bedrijf heeft gewerkt
   * @param tabel tabel die gebruikt moet worden voor de berekening
   * @param eenheid opzegtermijn in aantal weken, dagen, maanden?
   */
  berekenResultaat(ancieniteitMaand: number, tabel: OpzegtermijnItem[], eenheid: string, extraMaand:Boolean): string {
    var resultaat = null;

    //Indien het om jaartallen gaat, geen extra ancieniteit toevoegen (toepassing op tabel 3 en 6)
    if(extraMaand && ancieniteitMaand < 1900)
    {
      ancieniteitMaand += 1;
    }
    for (var i = 0; i < tabel.length; i++) {
      //Bereken het opzegtermijn door elementen te vergelijken in de toebehorende tabel
      if(ancieniteitMaand < 1900)
      {
        if (tabel[i].ancieniteit <= ancieniteitMaand) {
          console.log('aantal maand ' + ancieniteitMaand)
         resultaat = tabel[i].periode + this.naamgevingEenheid(eenheid,tabel[i].periode);
         
         //Indien gevonden, stop met zoeken
         i = 999;
       }
      }
      else
      {
        if (tabel[i].ancieniteit >= ancieniteitMaand) {
          console.log('aantal maand ' + ancieniteitMaand)
         resultaat = tabel[i].periode + this.naamgevingEenheid(eenheid,tabel[i].periode);
         
         //Indien gevonden, stop met zoeken
         i = 999;
       }
      }
      
    }
    
    this.berekenOutplacement(eenheid,parseInt(resultaat))
    return resultaat

  }

  /**
   * Retourneerd de huidige naamgeving van de eenheid in een enkelvoudige vorm indien het resultaat gelijk is aan 1
   * 
   * @param huidigeNaamgeving Huidige eenheid van het resultaat
   * @param resultaat aantal dagen/weken/maanden opzegtermijn
   */
  naamgevingEenheid(huidigeNaamgeving:string, resultaat: number): string
  {
    var naamgeving = huidigeNaamgeving;
    if(huidigeNaamgeving === " maanden")
    {
        if(resultaat == 1 )
        {
          naamgeving = " maand"
        }
    }
    else if(huidigeNaamgeving === " weken")
    {
      if(resultaat == 1 )
      {
        naamgeving = " week"
      }
    }
    else if(huidigeNaamgeving === " dagen")
    {
      if(resultaat == 1 )
      {
        naamgeving = " dag"
      }
    }
    return naamgeving
  }
  /**
   * Voegt 2 deelresultaten samen tot 1 geheel, die we dan kunnen afbeelden aan de gebruiker
   * 
   * @param d1 deelresultaat 1
   * @param d2 deelresultaat 2
   */
  samenvoegenDeelresultaat(d1: string, d2: string) {
    if(d2 != null || d2 != undefined)
    {
      this.resultaat = d1 + " en " + d2;
    }
    else
    {
      this.resultaat = d1;
    }
    
    if(this.totaalAantalWekenOpzegtermijn >= 30)
    {
      this.rechtOutplacement = true;
    }
  }

  //###############################################################################################################################################################################
  //Auto unsub
  ngOnDestroy() {
    this.componentDestoryed$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.componentDestoryed$.unsubscribe();
  }
}
